<template>
  <div class="card"   style="width: 600px; margin: 0 auto">
    <h2 >{{article.title}}</h2>
    <el-tag size="small">通知公告</el-tag>
    <span> {{article.createTime}}</span>
    <p v-html="article.content"/>
  </div>
</template>

<script>
import {getDaily} from "../api";

export default {
  name: 'noticeInfo',
  data() {
    return {
      article: {
        title:null,
        createTime:null,
        content:null,
      },
    }
  },
  created() {
    this.getMarquee();
  },
  mounted() {

  },
  methods: {
    getMarquee() {

      getDaily(this.$route.params.id).then(res => {
        this.article=res.data.data
        this.article.createTime=res.data.data.createTime.split(' ')[0];

      })
    },

  }
}
</script>

<style scoped>
.card{
  width: 80%;
  margin: auto;
}

</style>
